export enum AdminFeeType {
  tempo = "tempo",
  cash = "cash",
}
